import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  TOGGLE_SEARCH_DIALOG
} from './actionTypes'

const initializeState = Map({
  result: List(),
  showing: false
})

export default createReucer({
  [TOGGLE_SEARCH_DIALOG]: state =>
    state.update('showing', showing => !showing)
}, initializeState)
